var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('nav',{staticClass:"top-navigation-menu"},[_c('app-navbar')],1),_c('main',{staticClass:"flex"},[_c('app-sidebar'),_c('div',{staticClass:"main-content",class:{ 'nav-collapsed': _vm.isSideNavCollapsed }},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }